import store from '@shared/store/index';

export function callScannerBriefcaseFilter(){
  const isActiveBriefcase = store.getters['Scanner/filter/getIsBriefcase'];
  if(isActiveBriefcase){
    store.dispatch('Scanner/activeBriefcaseFilter');
  }
}